import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ExcelOrderImport_ModuleContextService } from './ExcelOrderImport.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ExcelOrderImport_vendorLots_dd_ComponentContextService {
  private readonly moduleContext: ExcelOrderImport_ModuleContextService;

  constructor(moduleContext: ExcelOrderImport_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'vendorLots_dd',
      type: ComponentType.selector
    }
  }
}